import api from '@/api';

export default {
  namespaced: true,

  state: {
    permissions: [],
  },

  actions: {
    async GetPermissions({ commit }) {
      const { permissions } = await api.permission.getPermissions();
      commit('SET_PERMISSIONS', permissions);
      return permissions;
    },
  },

  mutations: {
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
  },
};
